import DocumentApi from "../../../service/DocumentService";
import TaskApi from "../../../service/TaskService";
import GetMyActiveTaskRequest from "../../../service/request/GetMyActiveTaskRequest";
import CompleteTaskRequest from "../../../service/request/CompleteTaskRequest";
import SimpleWarningDialog from "../../../components/SimpleWarningDialog";
import { th } from "date-fns/locale";

export default {
  name: "ShowApproval",
  components: {
    SimpleWarningDialog
  },
  mixins: [],
  beforeMount() {
    this.tckn = this.$route.params.tckn;
  },
  data: function () {
    return {
      task: {},
      content: null,
      showSendToApprove: false,
      isApproving: false,
      pageCount: 0,
      currentPage: 1,
      approveText: "",
      rejectText: "",
      isLoading: true,
      successApproveDialog: false,
      secondaryBtn: true,
      loading: false,
      disabled: false,
      status: "",
      documentInterval: {},
      documentMSRetry: 0,
      documentMSRetryLimit: 1,
      document: null
    };
  },
  watch: {
    content: function (newValue) {
      if (newValue != null) {
        window.clearInterval(this.documentInterval);
      }
    }
  },
  computed: {
    taskSendToApprovalResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "sendToApprovalResult"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "sendToApprovalResult"
        ).value;
      }
      return null;
    },
    taskApprovalResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "approvalResult"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "approvalResult"
        ).value;
      }
      return null;
    },
    taskEnablePreApprovementResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "enablePreApprovement"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "enablePreApprovement"
        ).value;
      }
      return null;
    },
    
    taskRequirePreApprovementResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "requirePreApprovement"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "requirePreApprovement"
        ).value;
      }
      return null;
    },
    taskSendToPreApprovalResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "sendToPreApprovalResult"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "sendToPreApprovalResult"
        ).value;
      }
      return null;
    },
    taskPreApprovalResult: function () {
      if (
        this.task != null &&
        this.task.activeResourceTask != null &&
        this.task.activeResourceTask.processVariables != null &&
        this.task.activeResourceTask.processVariables.find(
          x => x.code == "preApprovalResult"
        ) != null
      ) {
        return this.task.activeResourceTask.processVariables.find(
          x => x.code == "preApprovalResult"
        ).value;
      }
      return null;
    },
    warningDialogText: function () {
      if (this.status === "true") {
        if (this.taskSendToApprovalResult) {
          if (
            this.taskApprovalResult != null &&
            this.taskApprovalResult != "retry"
          ) {
            return this.$t("processApprovedCheck");
          } else if (this.taskSendToApprovalResult === "retry") {
            return this.$t("documentSendApprove");
          }
        }
        return this.$t("documentApproved");
      } else if (this.status === "retry") {
        return this.$t("documentWaiting");
      } else {
        return this.$t("documentReject");
      }
    },
    warningDialogAction: function () {
      if (this.status === "retry") {
        this.secondaryBtn = false;
        return this.onDialogCanceled;
      } else {
        this.secondaryBtn = true;
        return this.onDialogApproved;
      }
    },
    warningText: function () {
      return this.$t("documentWaiting");
    }
  },
  destroyed() {
    window.clearInterval(this.documentInterval);
  },
  async mounted() {
    this.task = await this.retrieveTask();
    if (this.task != null) {
      if (
        (this.taskApprovalResult != null &&
          (this.taskApprovalResult == "true" ||
            this.taskApprovalResult == "false")) ||
        (this.taskSendToApprovalResult != null &&
          this.taskSendToApprovalResult == "false")
      ) {
        this.isApproving = true;
      } else {
        let taskResult = JSON.parse(this.task.activeResourceTask.parameters);
        this.approveText = taskResult.language.approveButton;
        this.rejectText = taskResult.language.rejectButton;
        this.isApproving = taskResult.language.type === 1;
      }
    }
    this.setDocumentWhenReady();
  },
  methods: {
    async setDocumentWhenReady() {
      this.content = null;
      // if (!this.document) {
      //   this.document = await this.retrieveDocument();
      // }
      await this.sleep(7000);
      this.document = await this.retrieveDocument();
      if (this.document) {
        this.documentMSRetry = 0;
        const blob = this.b64toBlob(this.document);
        this.content = URL.createObjectURL(blob);
        this.isLoading = false;
      } else if (this.documentMSRetry < this.documentMSRetryLimit) {
        this.documentMSRetry++;
        this.setDocumentWhenReady();
      } else {
        // this.documentMSRetry = 0;
        this.status = "retry";
        this.concludeApproval();
      }
    },
    retrieveDocument() {
      return new Promise(resolve => {
        DocumentApi.getRecent(
          this,
          "WEB_AGENT",
          this.$store.getters["processId"], //Edit Code
          "OBCF",
          response => {
            if (
              response &&
              response.documentFileWithIdDTO &&
              response.documentFileWithIdDTO.documentFileDTO
            ) {
              resolve(
                response.documentFileWithIdDTO.documentFileDTO.base64Bytes
              );
            } else {
              resolve(false);
            }
          },
          error => {
            console.log(error);
            resolve();
          }
        );
      });
    },
    b64toBlob(b64Data) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      const sliceSize = 512;

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: "application/pdf" });
      return blob;
    },
    onClickApprove() {
      this.status = "true";
      this.successApproveDialog = true;
    },
    onClickReject() {
      this.status = "false";
      this.successApproveDialog = true;
    },
    onDialogApproved() {
      this.concludeApproval();
    },
    onDialogCanceled() {
      this.successApproveDialog = false;
    },
    retrieveTask() {
      return new Promise(resolve => {
        const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
        
        if(this.$store.getters["processId"] != null){
        getMyActiveTaskRequest.processId = this.$store.getters["processId"];
      
        TaskApi.getMyActiveTask(
          this,
          getMyActiveTaskRequest,
          response => {
            resolve(response);
          },
          error => {
            console.log(error);
            resolve(null);
          }
        );
        }
      });
    },
    completeTask(taskId, status) {
      return new Promise(resolve => {
        const completeTaskRequest = new CompleteTaskRequest();
        completeTaskRequest.taskId = taskId;
        
if (this.taskSendToApprovalResult != null && this.taskSendToApprovalResult != "retry") {
  if (this.taskPreApprovalResult != null && this.taskPreApprovalResult != "retry") {
    if (this.taskApprovalResult != null && this.taskApprovalResult != "retry") {
      completeTaskRequest.variables = [
        {
          code: "finalResult",
          value: status
        }
      ];
    } else {
      completeTaskRequest.variables = [
        {
          code:
            this.taskPreApprovalResult == "false"
              ? "finalResult"
              : "approvalResult",
          value: status
        }
      ];
    }
  } else {
    if(this.taskApprovalResult != null && this.taskApprovalResult != "retry"){
      completeTaskRequest.variables = [
        {
          code: "finalResult",
          value: status
        }
      ];
    } else{
      completeTaskRequest.variables = [
        {
          code:
            this.taskSendToApprovalResult == "false"
              ? "finalResult"
              : ( this.taskEnablePreApprovementResult == "true"  &&  this.taskRequirePreApprovementResult == "true") 
                ? "preApprovalResult" : "approvalResult",
          value: status
        }
      ];
    }
  }
} else {
  completeTaskRequest.variables = [
    {
      code: "sendToApprovalResult",
      value: status,
    }
  ];

  if (status == "false") {
    completeTaskRequest.variables.push({
      code: "approverId",
      value: this.$store.getters["user"].id
    });
  }
}
  
        TaskApi.completeTask(
          this,
          completeTaskRequest,
          response => {
            resolve(response);
          },
          error => {
            console.log(error);
            resolve(null);
          }
        );
      });
    },
    async concludeApproval() {
      this.successApproveDialog = false;
      this.loading = true;
      this.disabled = true;

      this.task = await this.retrieveTask();
      if (this.task != null) {
        this.task = await this.completeTask(
          this.task.activeResourceTask.taskId,
          this.status
        );

        let routingComponent = this.task.activeResourceTask.resourceKey;

        const availableRoutes = this.$store.getters["menu"][0].children;
        if (!availableRoutes.some(route => route.code === routingComponent)) {
          routingComponent = availableRoutes.find(route => route.menuItem).code;
        }

        if (routingComponent == "ShowApproval") {
          this.isLoading = true;
          this.setDocumentWhenReady();
          this.loading = false;
          this.disabled = false;
          if (this.taskSendToApprovalResult == "false") {
            this.isApproving = true;
          }
        } else {
          const processid = this.$store.getters["processId"]
          this.$store.dispatch("clearProcessId");
          this.$router.push({
            name: routingComponent,
            params: {
              processid: processid,
              taskId: this.isApproving
                ? this.task.activeResourceTask.taskId
                : null
            }
          });
        }
      } else {
        this.loading = false;
        this.disabled = false;
      }
    },
    sleep(ms) {
      console.log("documentMSRetry: ", this.documentMSRetry);
      console.log("documentMSRetryLimit: ", this.documentMSRetryLimit);
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/approval/mixin/ShowApproval.js